import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { companyInfo, services } from '../data';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="inline-flex items-center">
              <div className="bg-white p-2 rounded-md inline-block">
                <img src="/logo.png" alt="FINANJU" className="h-10 w-auto" />
              </div>
            </Link>
            <p className="text-sm leading-relaxed text-slate-400">
              Din betroede partner inden for økonomisk og juridisk rådgivning. Vi skaber struktur og overblik for din virksomhed.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-6">Kontakt</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#876a57] shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm hover:text-white transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#876a57] shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-white transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Ydelser</h3>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.id}>
                  <Link to={service.link} className="text-sm hover:text-white transition-colors flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-[#876a57]"></span>
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-6">Virksomhed</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/om-finanju" className="text-sm hover:text-white transition-colors">
                  Om FINANJU
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-sm hover:text-white transition-colors">
                  Kontakt os
                </Link>
              </li>
              <li className="pt-4 mt-4 border-t border-slate-800">
                <span className="text-sm text-slate-500">CVR: {companyInfo.cvr}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-slate-950 py-6">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} FINANJU. Alle rettigheder forbeholdes.
          </p>
        </div>
      </div>
    </footer>
  );
}
